import * as React from 'react';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ApplicationState } from '../../store';
import { Dispatch } from 'redux';
import 'hammerjs';
// Components
import { GetString } from '../StringResourceManager';
import OverviewWidgetChart from '../OverviewWidgetChart';
import { ChartSeriesInterface } from '../../Interfaces/Devices/ChartSeriesInterface';
import { AssetStateCountBySite } from '../../Interfaces/Assets/AssetStateCountBySite';
import { SeriesClickEvent } from '@progress/kendo-react-charts';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { saveAssetStatusesFilters } from '../../store/UserSettings/UserSettingsActions';
import { ASSET } from '../../utils/constants';
import { ChartColors } from './ChartColors';
import { getTopLanesDownCountBySite } from '../../store/Devices/AssetStatesActions';

export default function DevicesOverview() {
  const [refresh, setRefresh] = useState<boolean>(true);

  const lanesDownCountBySite: AssetStateCountBySite[] = useSelector(
    (state: ApplicationState) => state.assetStatusesReducer.lanesDownCountBySite
  );

  const isFetchingLanesDownCountBySite: boolean = useSelector(
    (state: ApplicationState) =>
      state.assetStatusesReducer.isFetchingLanesDownCountBySite
  );

  const [topXStoresWithLanesDown, setTopXStoresWithLanesDown] = React.useState<
    string[]
  >([]);

  const [
    topXStoresWithLanesDownSeriesData,
    setTopXStoresWithLanesDownSeriesData,
  ] = React.useState<ChartSeriesInterface[]>([]);

  const dispatch: Dispatch<any> = useDispatch();

  useEffect((): ReturnType<React.EffectCallback> => {
    if (refresh) {
      setRefresh(false);
      getTopLanesDownCountBySite(dispatch, 5);
    }
    return (): void => {};
  }, [refresh]);

  useEffect((): ReturnType<React.EffectCallback> => {
    processTopXStoreWithIssuesChartData();
  }, [lanesDownCountBySite]);

  const processTopXStoreWithIssuesChartData = () => {
    let storeList: string[] = [];
    let seriesData: ChartSeriesInterface[] = [
      {
        status: undefined,
        count: [],
        color: ChartColors.Red,
      },
    ];

    for (let i = 0; i < lanesDownCountBySite.length; ++i) {
      if (lanesDownCountBySite[i].Count == 0) continue;

      storeList.push(lanesDownCountBySite[i].SiteNumber.toString());
      seriesData[0].count.push(lanesDownCountBySite[i].Count);
    }

    setTopXStoresWithLanesDown(storeList);
    setTopXStoresWithLanesDownSeriesData(seriesData);
  };

  const maxChartValueAxisItem: any = () => {
    return topXStoresWithLanesDownSeriesData.length > 0
      ? Math.max(...topXStoresWithLanesDownSeriesData[0].count) + 10
      : 0;
  };

  const onStoreNumberSeriesItemClick = (event: SeriesClickEvent) => {
    let filter: CompositeFilterDescriptor = {
      logic: 'and',
      filters: [
        {
          field: ASSET.FIELD_STORE_NAME,
          operator: 'eq',
          value: event.category,
        },
      ],
    };

    saveAssetStatusesFilters(dispatch, filter);
  };

  return (
    <OverviewWidgetChart
      chartTitleText={GetString('TOP_STORES_WITH_LANES_DOWN')}
      chartValueAxisItemtitle={GetString('NUMBER_OF_LANES_DOWN')}
      chartCategoryAxisItem={topXStoresWithLanesDown}
      maxChartValueAxisItem={maxChartValueAxisItem()}
      seriesData={topXStoresWithLanesDownSeriesData}
      chartSeriesClick={onStoreNumberSeriesItemClick}
      goToScreen="devices"
      chartType="bar"
      isRefreshing={isFetchingLanesDownCountBySite}
    />
  );
}
